import { render, staticRenderFns } from "./UpdateFields.vue?vue&type=template&id=188707a2&"
import script from "./UpdateFields.vue?vue&type=script&lang=js&"
export * from "./UpdateFields.vue?vue&type=script&lang=js&"
import style0 from "./UpdateFields.vue?vue&type=style&index=0&id=188707a2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports